export default __webpack_public_path__ + "static/media/Arrow.90b5cf29.svg";